import axios from 'axios';
import { unparse } from 'papaparse';
import { config } from '../config';
import { Contact, FaxSendResponse } from '~/common/types';
import { CsrfHelper } from '../helpers';

const helper = new CsrfHelper();

export class SendFaxHelper {
  public async faxSubmit(data: FormData): Promise<FaxSendResponse> {
    let reply: FaxSendResponse = {
      code: -1,
      message: 'Error sending fax to the queue',
      data: null,
    };

    await axios
      .post<FaxSendResponse>(config.faxSendUrl, data, {
        headers: helper.getCsrfHeader(),
        timeout: 300000,
      })
      .then((response) => {
        reply = response.data;
        /* CONTINUE HERE: 2020/09/10
                    var sendSuccess = data.code > 0;
            showSendMessage(sendSuccess, data.message);
            if (sendSuccess) {
              faxRemoveAllRecipients();
              isFaxFormModified = false;
              unbindBeforeUnload();
            }*/
      })
      .catch((e) => {
        reply.message = e.message;
      });

    return reply;
  }

  public serializeRecipientsArray(recipients: Array<Contact>): string {
    const NEWLINE = '\n';

    return (
      'faxnumber,firstname,lastname,company' +
      NEWLINE +
      unparse(recipients, {
        header: false,
        columns: ['fax', 'firstName', 'lastName', 'company'],
        newline: NEWLINE,
      })
    );
  }
}
